import { RefreshCw } from "lucide-react";
import type { ReactNode } from "react";

import { useGraphData } from "../app/GraphDataContext";

export function DataGate({ children }: { children: ReactNode }) {
  const { snapshot, loading, error, reload } = useGraphData();
  if (loading && !snapshot) {
    return <div className="system-loading"><span /> <strong>READING D1 GRAPH</strong></div>;
  }
  if (error || !snapshot) {
    return (
      <section className="api-failure">
        <p className="eyebrow">WORKER / D1 BOUNDARY</p>
        <h1>System graph unavailable.</h1>
        <p>{error ?? "No snapshot returned."}</p>
        <button className="command-button" onClick={reload}><RefreshCw size={16} aria-hidden="true" /> Retry API</button>
      </section>
    );
  }
  return children;
}
